import gql from 'graphql-tag';
import ASSET_FRAGMENT from './asset';

const RESOURCE_TYPE_ASSETS_FRAGMENT = gql`
  fragment BaseResourceTypeAssets on ResourceType {
    iconAsset {
      ...BaseAsset
    }
    imageAsset {
      ...BaseAsset
    }
  }
  ${ASSET_FRAGMENT}
`;

export default RESOURCE_TYPE_ASSETS_FRAGMENT;
